const FIELD_LABELS: Record<string, string> = {
    Title: "Title",
    Description: "Description",
    TicketStatusId: "Status",
    TicketTypeId: "Type",
    PriorityId: "Priority",
    TicketResolutionId: "Resolution",
    ReportedById: "Reporter",
    AssignedToId: "Assignee",
    ParentId: "Parent",
    DueDate: "Due date",
    FixVersions: "Fix versions",
    AffectVersions: "Affect versions",
    Labels: "Labels",
    DeletedAt: "Deleted",
};

/** Human label for a change-log field key; unknown keys pass through as-is. */
export function fieldLabel(field: string): string {
    return FIELD_LABELS[field] ?? field;
}

/** Long-text fields render as expandable before/after panes instead of inline chips. */
export function isLongTextField(field: string): boolean {
    return field === "Title" || field === "Description";
}
